var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Apple"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Apple",
    clipPath: "url(#clip-Apple)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apple-2",
    "data-name": "apple",
    transform: "translate(0.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4559",
    "data-name": "Path 4559",
    d: "M18.71,19.473c-.83,1.238-1.71,2.5-3.05,2.5s-1.77-.789-3.29-.789-2,.769-3.27.819S6.8,20.651,6,19.443C4.29,16.977,3,12.454,4.74,9.378A4.881,4.881,0,0,1,8.82,6.872c1.28,0,2.5.869,3.29.869s2.26-1.068,3.81-.909a4.642,4.642,0,0,1,3.64,2,4.551,4.551,0,0,0-2.15,3.8,4.4,4.4,0,0,0,2.68,3.994,11.026,11.026,0,0,1-1.38,2.826M13,3.5A4.552,4.552,0,0,1,15.94,2a4.369,4.369,0,0,1-1,3.185,3.652,3.652,0,0,1-3,1.418A4.259,4.259,0,0,1,13,3.5Z",
    fill: "#2e78d5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.148657ee86a641dc86f27b4ab262fe67.svg";
export { ForwardRef as ReactComponent };